import { ComplianceCategories } from '@ui/icons';
import { ComplianceCategory } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Menu } from 'antd';
import React, { useCallback } from 'react';
import { SearchOptionGroup } from './DataDictionarySearch';
const complianceCategories = Object.entries(ComplianceCategory).filter(([, id]) => typeof id === 'number');
const menuItems = [{
        children: complianceCategories.map(([, id]) => ({
            group: SearchOptionGroup.Compliance,
            key: id,
            label: React.createElement(ComplianceCategories, { categoryFlags: Number(id) }),
            value: id
        })),
        key: 'title',
        label: COPY_SPECIFIC.COMPLIANCE,
        type: 'group'
    }];
export const QuickAccessComplianceCategories = ({ onSelect }) => {
    const handleOnClick = useCallback((info) => {
        var _a;
        const [categoryName] = (_a = complianceCategories.find(([, id]) => id === Number(info.key))) !== null && _a !== void 0 ? _a : [];
        onSelect({
            complianceCategory: Number(info.key),
            displayName: categoryName
        });
    }, [onSelect]);
    return (React.createElement(Menu, { className: 'quick-access-menu', items: menuItems, mode: 'inline', onClick: handleOnClick }));
};
